import React from 'react'
import closeIcon from '../assets/img/close.png'
import ArchiveIcon  from '../assets/img/fileIcons/Archive.png'
import AudioIcon  from '../assets/img/fileIcons/Audio.png'
import ImageIcon  from '../assets/img/fileIcons/Image.png'
import TextIcon  from '../assets/img/fileIcons/Text.png'
import VideoIcon  from '../assets/img/fileIcons/Video.png'
import UndefinedIcon from '../assets/img/fileIcons/Undefined.png'

class FilePreviewComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: this.props.name,
            fileType: this.props.name.split(".").pop()
        }
    }

    getWrappedName = () => {
        if(this.state.name.length <= 10){
            return this.state.name;
        } else {
            let name = this.state.name;
            name = name.slice(0, 7);
            name += "..."

            return name
        }
    }

    render() {
        let imgSrc = {}
        switch (this.state.fileType) {
            case "jpg": case "png": case "jpeg": case "tif": case "gif":
                imgSrc = ImageIcon;
                break;
            case "mov": case "mp4": case "avi": case "mkv": case "wmv":
                imgSrc = VideoIcon;
                break;
            case "mp3": case "m4a": case "flac": case "wav": case "":
                imgSrc = AudioIcon;
                break;
            case "txt": case "pdf": case "docx": case "odt": case "rtf":
                imgSrc = TextIcon;
                break;
            case "rar": case "zip": case "7z": case "gz":
                imgSrc = ArchiveIcon;
                break;
            default:
                imgSrc = UndefinedIcon;
                break;
        }
        return (
            <div style={{ textAlign: "center", position: "relative" }} className="fileExChildComponent">
                <img
                    src={closeIcon}
                    alt="Close icon"
                    style={{ height: "1rem", cursor: "pointer", position: "absolute", right: 0 }}
                    onClick={this.props.onClick}
                />
                <img src={imgSrc} alt="" style={{ width: "30px", margin: "auto" }} />
                <div style={{ textAlign: "center" }}>
                    {this.getWrappedName()}
                </div>
            </div>
        )
    }


}
export default FilePreviewComponent;